import {TranslatableResourceType} from 'types';

import {TranslatableCellField, FieldMapping} from './types';

const metafields: {[key: string]: TranslatableCellField} = {
  meta_description: {
    component: 'text_field_with_limit',
    props: {
      multiline: true,
      suggestedLength: 320,
    },
  },
  meta_title: {
    component: 'text_field_with_limit',
    props: {
      multiline: true,
      suggestedLength: 70,
    },
  },
};

export const FIELDS_MAPPING: FieldMapping = {
  [TranslatableResourceType.Product]: {
    ...metafields,
  },
  [TranslatableResourceType.OnlineStoreArticle]: {
    ...metafields,
  },
  [TranslatableResourceType.OnlineStorePage]: {
    ...metafields,
  },
  [TranslatableResourceType.Collection]: {
    ...metafields,
  },
  [TranslatableResourceType.Shop]: {
    ...metafields,
    meta_description: {
      component: 'text_field_with_limit',
      props: {
        multiline: true,
        maxLength: 320,
      },
    },
  },
};
